import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=2883cb4a&"
import script from "./Phone.vue?vue&type=script&lang=ts&"
export * from "./Phone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports